import { useCheckPermission } from '../useUserRoles';
import { globalFeatureFlags } from '@/lib/featureFlags';

export const useDrawingsAccess = () => {
  const isFeatureEnabled = globalFeatureFlags.isEnabled('ENABLE_DRAWINGS_TAB');
  const { data: hasPermission, isLoading } = useCheckPermission('VIEW_DRAWINGS');

  return {
    data: isFeatureEnabled && hasPermission,
    isLoading: isFeatureEnabled ? isLoading : false,
  };
};

export const useDrawingManagePermission = () => {
  return useCheckPermission('MANAGE_DRAWINGS');
};

export const useDrawingUploadPermission = () => {
  return useCheckPermission('UPLOAD_DRAWINGS');
};
